import React, { forwardRef } from 'react';
import { Page } from '@/payload/payload-types';
import { Button, ButtonProps } from '../../_components/Button';

type FilteredProductsType = Extract<Page['layoutBlocks'][0], { blockType: 'filteredProducts' }>;

type FilterButtonProps = {
	filter: FilteredProductsType['filters'][0];
	isActive: boolean;
} & ButtonProps;

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
	({ filter, isActive, ...props }, ref) => (
		<Button
			intent={isActive ? 'secondary' : 'primary'}
			variant={isActive ? 'solid' : 'outlined'}
			className="border-gold-light font-semibold"
			ref={ref}
			{...props}
		>
			{filter.btnTitle}
		</Button>
	),
);

FilterButton.displayName = 'FilterButton';

export default FilterButton;
